<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">用户信息管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <div class="page-action-btns flex margin-tb-10">
        <!-- <button class="common-bg-button" @click="getLabels(true)">
          标签管理
        </button>
        <button class="common-bg-button" @click="disDealerDialog('dealerForm')">
          分配运营商
        </button> -->
        <!-- <button class="common-bg-button" @click="editDialog()">
          编辑
        </button> -->
        <button class="common-bg-button" @click="editDialog()">
          查看
        </button>
        <!-- <button class="common-bg-button" @click="DealerDialog()">
          操作日志
        </button> -->
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">
          重 置
        </button>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuerys = !showMultiQuerys;
          }
        ">
          高级筛选
        </button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">手机号：</p>
              <el-input v-model="queryInfo.mobile" size="small" clearable placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">账号类型：</p>
              <el-select v-model="queryInfo.custType" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="共享管理账号" value="共享管理账号" />
                <el-option label="共享充电账号" value="共享充电账号" />
                <el-option label="桩主账号" value="桩主账号" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">注册渠道：</p>
              <el-select v-model="queryInfo.registerSource" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="支付宝个人站" value="DEV_SHARE_ALI" />
                <el-option label="微信个人站" value="DEV_SHARE_WECHAT" />
                <el-option label="挚达APP" value="ZHI_DA_APP" />
                <el-option label="桩到家支付宝小程序" value="ZHI_ZHI_FU_BAO_APP" />
                <el-option label="挚达支付宝小程序" value="ZHI_DA_ZHI_FU_PAY" />
                <el-option label="桩到家微信小程序" value="ZDJ_ZHI_FU_PAY" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">绑定充电桩：</p>
              <el-input v-model="queryInfo.pileCode" size="small" clearable placeholder="请输入充电桩编号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">注册时间：</p>
              <div class="flex-r">
                <el-date-picker v-model="queryInfo.registerStartTime" type="date" size="small" placeholder="开始日期"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                <div class="separate-center-div"></div>
                <!-- :picker-options="pickerEndOptions" -->
                <el-date-picker v-model="queryInfo.registerEndTime" type="date" size="small" placeholder="结束日期"
                  value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否绑定充电桩：</p>
              <el-select class="full-width" size="small" v-model="queryInfo.isBind" clearable placeholder="请选择绑定状态">
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">绑定设备类型：</p>
              <el-select class="full-width" size="small" v-model="queryInfo.deviceType" clearable
                placeholder="请选择绑定设备类型">
                <el-option label="共享开关" value="共享开关" />
                <el-option label="充电桩" value="充电桩" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否开通私桩共享：</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareActive" clearable
                placeholder="请选择开通私桩共享">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" style="width: 100%" border stripe @selection-change="
          (sels) => {
            selections = sels;
            console.log('表格选择变化:', sels); // 调试日志
          }
        ">
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column prop="custNo" label="客户编号" width="200" align="center" />
          <el-table-column prop="mobile" label="" width="200" align="center" :key="Math.random()">
            <div slot="header" style="
                display: flex;
                align-items: center;
                justify-content: center;
              ">
              <span style="margin-right: 8px">客户手机号</span>
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
                v-if="!isFlag" @click="flagChange()" />
              <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt="" v-if="isFlag"
                @click="flagChange()" />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.mobile }}</span>
              <span v-else>{{
                scope.row.mobile
                  ? scope.row.mobile.replace(
                    scope.row.mobile.substring(2, 9),
                    "*******"
                  )
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="registerSourceName" label="注册渠道" width="200" align="center" />
          <el-table-column prop="custType" label="账号类型" width="200" align="center" />
          <el-table-column prop="registerTime" label="注册时间" width="200" align="center" />
          <el-table-column prop="loginTime" label="最近登录时间" width="200" align="center" />
          <el-table-column prop="loginSourceName" label="最近登录来源" width="200" align="center" />
          <el-table-column prop="latestChargeDate" label="最近充电时间" width="200" align="center" />
          <el-table-column prop="totalChargeTimes" label="累计充电次数" width="200" align="center" />
          <el-table-column prop="totalCount" label="累计充电量（kW·h）" width="200" align="center" />
          <el-table-column prop="totalFee" label="累计收益（元）" width="200" align="center" />
          <el-table-column prop="deviceTypeName" label="绑定设备类型" width="200" align="center" />
          <el-table-column prop="shareActiveName" label="是否开启私桩共享" width="200" align="center" />
          <el-table-column prop="pileCode" label="绑定设备编码" width="200" align="center" />
          <!-- <el-table-column prop="pileCodes" label="绑定设备二维码" width="200" align="center" /> -->
          <!-- <el-table-column prop="pileCodes" label="是否开通私桩共享" width="200" align="center" /> -->
          <!-- <el-table-column prop="pileCodes" label="当前私桩共享模式" width="200" align="center" /> -->
        </el-table>
        <!-- <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        >
          <template v-slot="scope">{{ scope.row.mobile }}</template>
        </ZD-table> -->
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
    <el-dialog title="标签管理" :visible.sync="labelVisible">
      <el-form :model="labelForm" :rules="pageConfig.labelFormRules" ref="labelForm" label-width="100px">
        <div class="flex">
          <el-form-item label="标签名称" prop="configName">
            <el-input size="small" style="width: 300px; margin-right: 10px" v-model="labelForm.configName"></el-input>
          </el-form-item>
          <!-- <el-form-item  label="编号" prop="configVal">
                        <el-input size="small" style="width:300px;margin-right:10px;" v-model="labelForm.configVal"></el-input>
                    </el-form-item>-->
          <el-button size="small" class="margin-tb" type="primary" @click="addLabelFun('labelForm')">新增标签</el-button>
        </div>
      </el-form>
      <div style="margin-bottom: 10px">合计客户数：{{ labelSum }}</div>
      <ZD-table :tableColumns="pageConfig.dialogListColumns" :operates="dialogOperates" :tableData="labelsArr"
        :tableConfig="pageConfig.dialogTableConfig" :selections="selections" v-on:updateSelections="
          (sels) => {
            selections = sels;
          }
        "></ZD-table>
      <!-- <span slot="footer" class="dialog-footer">
                <button class="common-empty-button" @click="dialogTableVisible = false">取 消</button>
                <button class="common-bg-button" type="primary" @click="dialogTableVisible = false">确 定</button>
            </span>-->
    </el-dialog>
    <el-dialog title="分配运营商" :visible.sync="dealerVisible">
      <el-form :model="dealerForm" :rules="pageConfig.dealerFormRules" ref="dealerForm" label-width="100px">
        <div style="margin: 0px 0px 20px 15px">
          请提前确认该客户已经在桩到家APP中注册提交后该客户便属于运营商的客户
        </div>
        <el-form-item label="运营商全称" prop="dealerNo">
          <el-select size="small" style="width: 300px" v-model="dealerForm.dealerNo" filterable placeholder="请输入关键词">
            <el-option v-for="item in dealerList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input size="small" style="width: 300px" v-model="dealerForm.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="common-empty-button" @click="dealerVisible = false">
          取 消
        </button>
        <button class="common-bg-button" type="primary" @click="addCustFun('dealerForm')">
          确 定
        </button>
      </span>
    </el-dialog>
    <el-dialog title="选择标签(可多选)" :visible.sync="selectLabelVisible" width="40%">
      <el-form :model="selectLabelForm" :rules="pageConfig.selectFormRules" ref="selectLabelForm">
        <el-form-item prop="dealerName">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in labelsArr" :key="item.id" :label="item.id">{{ item.configName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="common-empty-button" @click="selectLabelVisible = false">
          取 消
        </button>
        <button class="common-bg-button" type="primary" @click="selectLabelFun()">
          确 定
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys: false, //高级筛选
      queryInfo: {}, //标签页 搜索字段
      labelVisible: false, //标签管理弹窗
      dealerVisible: false, //分配运营商弹窗
      selectLabelVisible: false, //选择标签弹窗
      labelName: "11", //	未使用
      labelForm: {}, //标签管理内容
      dealerForm: {}, //分配运营商内容
      checkList: [], //选中标签
      labelsArr: [], //客户标签
      selectLabelForm: {}, //所有标签内容
      labelSum: 0, //合计客户数量 默认0
      operates: {
        width: 220,
        fixed: "right",
        list: [
          // {
          //   id: "report",
          //   label: "详情",
          //   type: "primary",
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit("setEditId", row.id);
          //     // this.$router.push({
          //     // 	name: pageConfig.custDeatilRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({
          //         name: pageConfig.custDeatilRouter,
          //       }).href,
          //       "_blank"
          //     );
          //   },
          // },
          // {
          //   id: "expenses",
          //   label: "标签",
          //   type: "primary",
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.checkList = [];
          //     this.selectLabelForm.mobile = row.mobile;
          //     this.$H
          //       .post(this, this.$A.config.list, {
          //         configType: "187",
          //         mobile: row.mobile,
          //       })
          //       .then((res) => {
          //         this.labelsArr = res.data.data;
          //         this.checkList = row.custDto.custType.split(",");
          //         this.selectLabelVisible = true;
          //       });
          //   },
          // },
        ],
      }, // 列操作按钮
      dialogOperates: {
        width: 100,
        fixed: "right",
        list: [
          {
            id: "del",
            label: "删除",
            type: "danger",
            show: true,
            disabled: false,
            method: (index, row) => {
              if (row.configDisp > 0) {
                this.$U.error("标签数不为0，不可删除！");
                return;
              }
              let url = this.$A.config.config + "/" + row.id;
              this.$U.showLoading(this);
              this.$H.del(this, url, {}).then((res) => {
                this.getLabels(true);
                this.$U.hideLoading(this);
              });
            },
          },
        ],
      }, // 列操作按钮
      searchTime: [], //注册时间
      firstSearchTime: [], //首次充电时间
      lastSearchTime: [], //最近充电时间
      options: [], //未使用
      value: [], //未使用
      pileList: [], //桩列表
      loading: false, //未使用
      dealNameArr: [], //未使用
      dealerList: [], //未使用
      //btnUse: false,
    };
  },
  methods: {
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    init() {
      // this.getPileList();
      // 首次加载不调用接口
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      
      // 检查是否有输入查询条件
      const hasQueryCondition = 
        (_.queryInfo.mobile && _.queryInfo.mobile.trim()) ||
        _.queryInfo.custType ||
        _.queryInfo.registerSource ||
        (_.queryInfo.pileCode && _.queryInfo.pileCode.trim()) ||
        _.queryInfo.registerStartTime ||
        _.queryInfo.registerEndTime ||
        _.queryInfo.isBind ||
        _.queryInfo.deviceType ||
        _.queryInfo.shareActive;
      
      if (!hasQueryCondition) {
        _.$U.error("请输入至少一个查询条件");
        return;
      }
      
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.cust.list, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    //获取桩列表
    getPileList() {
      let _ = this;
      _.$H.post(_, _.$A.cust.custpile, {}).then((res) => {
        _.pileList = res.data.data;
      });
    },
    // 选择注册时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
    //选择最近充电时间
    lastHandleDateChange(val) {
      if (val) {
        this.queryInfo.dtFromLatest = val[0];
        this.queryInfo.dtToLatest = val[1];
      } else {
        delete this.queryInfo.dtFromLatest;
        delete this.queryInfo.dtToLatest;
      }
    },
    //选择首次充电时间
    firstHandleDateChange(val) {
      if (val) {
        this.queryInfo.dtFromFirst = val[0];
        this.queryInfo.dtToFirst = val[1];
      } else {
        delete this.queryInfo.dtFromFirst;
        delete this.queryInfo.dtToFirst;
      }
    },
    //标签管理
    getLabels(flag) {
      this.$H
        .post(this, this.$A.config.list, {
          configType: "187",
        })
        .then((res) => {
          this.labelsArr = res.data.data;
          if (flag) {
            this.labelManageDialog();
          }
        });
    },
    //打开标签弹窗
    labelManageDialog() {
      this.labelsArr.forEach((item) => {
        this.labelSum = this.labelSum + item.configDisp;
      });
      this.labelVisible = true;
    },
    //分配运营商
    disDealerDialog(formName) {
      let _ = this;
      _.$H.get(_, _.$A.cust.allDealer, { pageSize: 999 }).then((res) => {
        _.dealerList = [];
        res.data.data.content.forEach((item) => {
          _.dealerList.push({
            value: item.dealNo,
            label: item.dealName,
          });
        });
        this.dealerForm = {};
        this.dealerVisible = true;
      });
    },
    //查看详情
    checkInfoDialog() {
      let _ = this;
      _.$H.get(_, _.$A.cust.allDealer, { pageSize: 999 }).then((res) => {
        _.dealerList = [];
        res.data.data.content.forEach((item) => {
          _.dealerList.push({
            value: item.dealNo,
            label: item.dealName,
          });
        });
        this.dealerForm = {};
        this.dealerVisible = true;
      });
    },
    //新增标签
    addLabelFun(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H.post(_, _.$A.cust.addtarget, _.labelForm).then((res) => {
            _.labelManageDialog();
            _.getLabels();
            _.labelForm.configName = "";
            _.$U.hideLoading(_);
          });
        }
      });
    },
    //提交分配运营商
    addCustFun(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H.post(_, _.$A.cust.addupdatecust, _.dealerForm).then((res) => {
            _.dealerVisible = false;
            _.$U.success("分配成功");
            _.init();
          });
        }
      });
    },
    //选择标签提交
    selectLabelFun() {
      let _ = this;
      _.selectLabelVisible = false;
      let labelName = "";
      _.checkList.forEach((item) => {
        labelName = labelName + item + ",";
      });
      labelName = labelName.substring(0, labelName.lastIndexOf(","));
      _.selectLabelForm.custType = labelName;
      _.selectLabelForm.editParam = "custType";
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.cust.targetremark, _.selectLabelForm).then((res) => {
        _.$U.hideLoading(_);
        _.getListData(this.pagination);
        _.$U.success("保存成功");
      });
    },
    //改功能已注销
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    editDialog() {
      let _ = this;
      if (_.checkSelectOne()) {
        console.log("选中的客户数据:", _.selections[0]); // 调试日志
        _.$store.commit("setCustObj", _.selections[0]);

        // 确认数据已经设置到store中
        setTimeout(() => {
          console.log("确认store中的数据:", _.$store.state.custObj);
          _.$router.push({
            name: "custData",
          });
        }, 100);
      }
    },
    //选择表格
    checkSelectOne() {
      console.log("当前选中的数据数量:", this.selections.length); // 调试日志
      if (this.selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (this.selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //导出
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      //_.btnUse = true;
      _.$H.post(_, _.$A.cust.exportCustList, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        //_.btnUse = false;
        _.$U.hideLoading(_);
      });
    },
    //重置
    reset() {
      this.pagination.current = 1;
      this.queryInfo = {};
      // 重置后不自动查询，需要手动输入条件后点击搜索
      this.tableData = [];
      this.pagination.total = 0;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
